import { EditablePersonInfo } from '@/data/Content/PersonInfo';
import { Box, Divider, Typography } from '@mui/material';
import { ACCOUNT_TABS } from '@/components/content/Account/parts/Tabs';
import { AccountSummaryPersonalInfo } from '@/components/content/Account/parts/SummaryPersonalInfo';
import { AccountSummaryTitleSX } from '@/components/content/Account/styles/summary';
import { useClubDpCards } from '@/data/Content/ClubDp';
// import { AccountSummaryRewards } from '@/components/content/Account/parts/AccountSummaryRewards';
import { useOrderHistoryWithDetails } from '@/data/Content/OrderHistory';
import { AccountSummaryOrders } from '@/components/content/Account/parts/AccountSummaryOrders';
import { ContentProvider } from '@/data/context/content';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import React, { useMemo } from 'react';
import { AccountSummaryDpvale } from '@/components/content/Account/parts/AccountSummaryDpvale';
import { SummarySkeleton } from '@/components/content/Account/parts/Skeletons/SummarySkeleton';

interface AccountSummaryProps {
	personInfo: EditablePersonInfo;
	onSelectedTab: (tab: ACCOUNT_TABS) => void;
}

export const AccountSummary: React.FC<AccountSummaryProps> = ({ personInfo, onSelectedTab }) => {
	const { rawData, loading } = useClubDpCards();
	const orderHistoryValues = useOrderHistoryWithDetails({
		pageNumber: 1,
		pageSize: 3,
	});
	const isMobile = useIsMobile();

	const orders = useMemo(() => {
		const [recentOrder] = orderHistoryValues.ordersWithItemsDetails;
		return recentOrder ? [recentOrder] : [];
	}, [orderHistoryValues.ordersWithItemsDetails]);

	if (loading || orderHistoryValues.loading) {
		return <SummarySkeleton />;
	}

	const linkedDpVale = !!rawData?.linked.puntosDpVale;

	const elementOrders = (
		<React.Fragment>
			{orders.length > 0 ? (
				<ContentProvider value={{ ...orderHistoryValues }}>
					<Divider sx={{ marginTop: 3, marginBottom: 3 }} />
					<AccountSummaryOrders
						orders={orderHistoryValues.ordersWithItemsDetails}
						mobile={isMobile}
						onReOrder={orderHistoryValues.onReOrder}
						onSelectedTab={onSelectedTab}
					/>
				</ContentProvider>
			) : null}
		</React.Fragment>
	);

	const elementDpvale = (
		<React.Fragment>
			<Divider sx={{ marginTop: 3, marginBottom: 3 }} />
			<AccountSummaryDpvale rawData={rawData} onSelectedTab={onSelectedTab} />
		</React.Fragment>
	);

	return (
		<Box>
			<Typography component={'h1'} sx={AccountSummaryTitleSX}>
				{'RESUMEN DE TU CUENTA'}
			</Typography>
			<AccountSummaryPersonalInfo personInfo={personInfo} onSelectedTab={onSelectedTab} />
			{/* <Divider sx={{ marginTop: 3, marginBottom: 3 }} /> */}
			{/* <AccountSummaryRewards rawData={rawData} onSelectedTab={onSelectedTab} /> */}
			{linkedDpVale ? (
				<React.Fragment>
					{elementDpvale}
					{elementOrders}
				</React.Fragment>
			) : (
				<React.Fragment>
					{elementOrders}
					{elementDpvale}
				</React.Fragment>
			)}
		</Box>
	);
};
